import { DateTime } from "../../utils/luxon.js";
import type { Product } from "../Product.js";

export function isShippingLater(
	shippingStartsAt: Product["shippingStartsAt"],
	now: number,
): shippingStartsAt is string {
	return shippingStartsAt !== undefined && shippingStartsAt > DateTime.fromMillis(now).toISODate();
}
